module.exports = __webpack_public_path__ + "img/ser2.00363b4c.png";